export const DefaultPageTitle = {
    surveyPageTitle: "Survey",
    homePageTitle: "Home",
    loginPageTitle: "Login",
    myHelpCenterPageTitle: "Help Center",
    ghTitle: "Guided Help"
}